export const ZapMock = () => {
  return (
    <svg
      width="174"
      height="137"
      viewBox="0 0 174 137"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M86.6533 43.1016V98.5206"
        stroke="#B5B2AA"
        strokeWidth="1.23153"
      />
      <rect
        x="25.4359"
        y="19.7495"
        width="123.052"
        height="37.4636"
        rx="3.30359"
        fill="#FFFDF9"
        stroke="#D7D3C9"
        strokeWidth="0.717419"
      />
      <rect
        x="25.4359"
        y="79.7904"
        width="123.052"
        height="37.4601"
        rx="3.30359"
        fill="#FFFDF9"
        stroke="#D7D3C9"
        strokeWidth="0.717419"
      />
      <circle cx="35.7523" cy="29.6258" r="4.82655" fill="#ECE9DF" />
      <rect
        x="44.7822"
        y="27.1632"
        width="31.7752"
        height="4.92613"
        rx="2.46307"
        fill="#ECE9DF"
      />
      <rect
        x="30.9258"
        y="39.2385"
        width="112.069"
        height="7.72555"
        rx="1.43484"
        fill="#F5F3EB"
      />
      <path
        d="M86.6544 108.783C89.2402 108.783 91.72 107.702 93.5484 105.777C95.3768 103.853 96.4041 101.242 96.4041 98.5204C96.4041 95.7985 95.3768 93.1882 93.5484 91.2635C91.72 89.3389 89.2402 88.2576 86.6544 88.2576C84.0687 88.2576 81.5888 89.3389 79.7604 91.2635C77.932 93.1882 76.9048 95.7985 76.9048 98.5204C76.9048 101.242 77.932 103.853 79.7604 105.777C81.5888 107.702 84.0687 108.783 86.6544 108.783ZM91.4025 97.4941L85.6795 104.678V99.5467H81.9064L87.6294 92.3627V97.4941H91.4025Z"
        fill="#D7D3C9"
      />
    </svg>
  );
};
